import faycalData from "./faycal.json";
import sanaeData from "./sanae.json";
import sanaePic from "../assets/sanae.webp";
import faycalPic from "../assets/faycal.webp";

interface ProfileSource {
	data: Record<string, unknown>;
	profilPic: string;
}

interface ProfileSourcesMap {
	[key: string]: ProfileSource;
}

const DEFAULT_PROFILE_VARIANT = "faycal";
const dataToUse = DEFAULT_PROFILE_VARIANT;

const profileSources: ProfileSourcesMap = {
	faycal: { data: faycalData, profilPic: faycalPic },
	sanae: { data: sanaeData, profilPic: sanaePic },
};

function getProfileData({ dataSource }: { dataSource: string }) {
	const normalizedVariant = dataSource.trim().toLowerCase();
	return profileSources[normalizedVariant] ?? profileSources[DEFAULT_PROFILE_VARIANT];
}

const { data, profilPic } = getProfileData({ dataSource: dataToUse });

export { data, profilPic };
